class InstancesDialog {
    constructor(openBtn) {
        this.openBtn = openBtn;

        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        const fromValue = params.get("from");

        if (fromValue == "whats-on") {
            this.openBtn?.click();
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const isEvent = document.body.classList.contains("single-event");

    if (isEvent) {
        const openBtn = document.querySelector(
            `[data-dialog="eventInstancesDialog"]`,
        );

        new InstancesDialog(openBtn);
    }
});
